export default "__VITE_ASSET__0731c5c2__"